import type { App } from 'vue';
import debounce from './debounce';
import imageLoading from './imageLoading';

// 全局注册 directive
export function setupDirective(app: App<Element>) {
  // 使 v-hasPerm 在所有组件中都可用
  app.directive('debounce', debounce);
  app.directive('image-loading', imageLoading);
}
